<template>
<footer>
  <nav class="footer-menu">
    <ul>
      <li>
        <a href="http://himeko.co.jp/">運営会社</a>
      </li>
      <li>
        <a v-bind:href="domain + '/terms'">利用規約</a>
      </li>
      <li>
        <a v-bind:href="domain + '/privacy'">プライバシーポリシー</a>
      </li>
      <li>
        <a v-bind:href="domain + '/law'">特定商取引法の表示</a>
      </li>
      <li>
        <a v-bind:href="domain + '/faq'">よくある質問</a>
      </li>
      <li>
        <a v-bind:href="domain + '/contact'">お問い合わせ</a>
      </li>
    </ul>
  </nav>
  <!-- .copy-right -->
  <div class="copy-right">Copyright © HIMEKO COMPANY Inc. All Rights Reserved.</div>
</footer>
</template>

<script>
export default {
  data () {
    return {
      domain: process.env.DOMAIN
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue